import React from "react"

import OptimizedImage from "../../../../shared-components/optimized-image"
import { Image } from "../../types"
import * as styles from "./index.module.scss"

export type Props = {
  image: Image
}

const BlogImage = ({ image }: Props) => (
  <figure className={styles.figure}>
    <OptimizedImage
      src={image.url}
      alt={image.alt}
      preset="editorial"
      loading="lazy"
    />
  </figure>
)

export default BlogImage
